module.exports = __webpack_public_path__ + "img/photo-and-video.7a29a169.webp";